import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { getJson } from '../../utility/request';
import { formatDollars } from '../../utility/formatters';
export default (props) => {
    var _a;
    const [data, setData] = React.useState(null);
    React.useEffect(() => {
        const qs = props.excludeInvoiceId ? `?exclude=${encodeURIComponent(props.excludeInvoiceId)}` : '';
        getJson(`/merchants/${props.merchantId}/billing-accounts/${props.clientId}/outstanding${qs}`)
            .then(setData)
            .catch(() => setData(null));
    }, [props.merchantId, props.clientId, props.excludeInvoiceId]);
    if (!data)
        return null;
    const projected = data.outstanding_balance + ((_a = props.additionalAmount) !== null && _a !== void 0 ? _a : 0);
    if (data.credit_limit === null) {
        return _jsxs("div", { className: "small text-muted mt-2", children: ["Outstanding on account: ", formatDollars(data.outstanding_balance)] });
    }
    const overage = projected - data.credit_limit;
    if (overage <= 0) {
        return _jsxs("div", { className: "small text-muted mt-2", children: ["Outstanding ", formatDollars(data.outstanding_balance), " of ", formatDollars(data.credit_limit), " credit limit."] });
    }
    return _jsxs("div", { className: "alert alert-warning mt-2 mb-0 py-2 small", children: ["This account will exceed its credit limit by ", _jsx("strong", { children: formatDollars(overage) }), ". Outstanding ", formatDollars(data.outstanding_balance), !!props.additionalAmount && _jsxs(_Fragment, { children: [" + ", formatDollars(props.additionalAmount), " on this invoice"] }), " vs limit ", formatDollars(data.credit_limit), "."] });
};
